module.exports = __webpack_public_path__ + "media/images/project/filter-6afd2c8920755419ef89dc3a3ad20f51.svg";